<div class="card">
        <p-captcha id="captcha" [siteKey]="this.RecaptchaPublicKey" (onResponse)="showResponse($event)"></p-captcha>
</div>